module.exports = __webpack_public_path__ + "static/media/ios.3cd24f82.svg";